(function (root) {
  'use strict';

  function nextPaused(userPaused, reduceMotion, toggle) {
    var pausedByUser = toggle ? !userPaused : userPaused;
    return {
      userPaused: pausedByUser,
      paused: pausedByUser || !!reduceMotion
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { nextPaused: nextPaused };
  }

  if (!root.document) return;

  /* Same breakpoint as theme.config.mediaQuerySmall. Do not edit theme.js.
     While a trust strip is the visible announcement, this coordinator owns
     the shared sticky class/variable and asks the native controller to
     release them, so a hidden announcement bar cannot keep shifting the header. */
  var NARROW_QUERY = 'screen and (max-width: 769px)';
  var INTERACTIVE = 'a, button, input, select, textarea, [tabindex]';

  var coord = root.__lshkShellCoordinator;
  if (!coord) {
    coord = root.__lshkShellCoordinator = {
      list: [],
      registry: new WeakMap(),
      bound: false,
      releasedNative: false,
      wasOwner: false,
      allowNativeRestore: true,
      pendingNativeRestore: false
    };
  }
  if (!coord.narrow) coord.narrow = root.matchMedia(NARROW_QUERY);
  if (!coord.reduceMotion) coord.reduceMotion = root.matchMedia('(prefers-reduced-motion: reduce)');

  function cssEscape(value) {
    if (root.CSS && typeof root.CSS.escape === 'function') return root.CSS.escape(String(value));
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function isTrue(value) {
    return value === 'true';
  }

  function parityOn() {
    return !!(root.document.body && root.document.body.classList.contains('lshk-sg-parity'));
  }

  function shellsFrom(node) {
    var found = [];
    function add(el) {
      if (el && found.indexOf(el) === -1) found.push(el);
    }
    var scope = node && node.querySelectorAll ? node : root.document;
    if (scope.nodeType === 1 && scope.matches && scope.matches('.lshk-announcement-shell')) add(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('.lshk-announcement-shell').forEach(add);
    }
    return found;
  }

  function ownsVisibleStrip() {
    if (!parityOn()) return false;
    return coord.list.some(function (inst) {
      return inst.strip.isConnected && !inst.strip.hasAttribute('hidden');
    });
  }

  function disarmClones(strip) {
    strip.querySelectorAll('.lshk-trust-strip__list[aria-hidden="true"]').forEach(function (list) {
      list.setAttribute('inert', '');
      list.querySelectorAll(INTERACTIVE).forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  function applyPause(inst) {
    var reduced = coord.reduceMotion.matches;
    var state = nextPaused(inst.userPaused, reduced, false);
    var paused = state.paused || inst.editorPaused;
    inst.strip.classList.toggle('is-paused', paused);
    inst.strip.classList.toggle('is-reduced', reduced);
    if (inst.pauseButton) {
      inst.pauseButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }
    queueGeometry();
  }

  function detectBelowHeader(strip) {
    /* Native theme.js only has one announcement, so "previous header-group
       sibling" means the header. Multiple strips are contiguous header-group
       sections; a preceding announcement is not the header. Below means a
       preceding header-group section actually contains the site header. */
    var section = strip.closest('.shopify-section-group-header-group');
    if (!section) return false;
    var sibling = section.previousElementSibling;
    while (sibling && sibling.classList && sibling.classList.contains('shopify-section-group-header-group')) {
      if (sibling.querySelector('.site-header, #SiteHeader')) return true;
      sibling = sibling.previousElementSibling;
    }
    return false;
  }

  function stickyAllowed(inst) {
    if (!parityOn() || inst.strip.hasAttribute('hidden') || !inst.strip.isConnected) return false;
    if (!isTrue(inst.strip.getAttribute('data-sticky'))) return false;
    if (coord.narrow.matches && !isTrue(inst.strip.getAttribute('data-sticky-mobile'))) return false;
    return true;
  }

  function removeSpacer(inst) {
    if (inst.spacer && inst.spacer.parentNode) inst.spacer.parentNode.removeChild(inst.spacer);
    inst.spacer = null;
    if (!inst.shell || !inst.shell.querySelectorAll) return;
    inst.shell.querySelectorAll('.lshk-trust-spacer').forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function ensureSpacer(inst) {
    var existing = inst.shell.querySelector('.lshk-trust-spacer');
    if (existing) {
      inst.spacer = existing;
      return existing;
    }
    var spacer = root.document.createElement('div');
    spacer.className = 'lshk-trust-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    inst.strip.insertAdjacentElement('afterend', spacer);
    inst.spacer = spacer;
    return spacer;
  }

  function measureTop(inst) {
    if (inst.spacer) inst.spacer.style.height = '0px';
    inst.barTop = inst.strip.getBoundingClientRect().top + root.scrollY;
    return inst.barTop;
  }

  function syncPauseSpace(inst) {
    var button = inst.pauseButton;
    if (!button) return;
    var buttonStyle = root.getComputedStyle(button);
    if (buttonStyle.display === 'none' || buttonStyle.visibility === 'hidden') {
      if (inst.strip.style.getPropertyValue('--lshk-pause-space')) inst.strip.style.removeProperty('--lshk-pause-space');
      return;
    }
    var widest = button.getBoundingClientRect().width;
    button.querySelectorAll('.lshk-trust-strip__pause-label, .lshk-trust-strip__play-label').forEach(function (label) {
      var hidden = root.getComputedStyle(label).display === 'none';
      var previous = label.style.display;
      if (hidden) label.style.display = 'inline';
      var labelWidth = label.getBoundingClientRect().width;
      if (hidden) label.style.display = previous;
      var chrome = (parseFloat(buttonStyle.paddingLeft) || 0) + (parseFloat(buttonStyle.paddingRight) || 0) + (parseFloat(buttonStyle.borderLeftWidth) || 0) + (parseFloat(buttonStyle.borderRightWidth) || 0);
      if (labelWidth + chrome > widest) widest = labelWidth + chrome;
    });
    var nextSpace = widest > 0 ? Math.ceil(widest + 12) + 'px' : '';
    var currentSpace = String(inst.strip.style.getPropertyValue('--lshk-pause-space') || '').trim();
    if (currentSpace === nextSpace) return;
    if (!nextSpace) inst.strip.style.removeProperty('--lshk-pause-space');
    else inst.strip.style.setProperty('--lshk-pause-space', nextSpace);
  }

  function syncSticky(inst) {
    inst.belowHeader = detectBelowHeader(inst.strip);
    if (!stickyAllowed(inst)) {
      inst.strip.classList.remove('is-stuck');
      inst.strip.style.top = '';
      removeSpacer(inst);
      inst.barTop = null;
      return;
    }
    if (!inst.strip.classList.contains('is-stuck') || inst.barTop == null) measureTop(inst);
    var stuck = root.scrollY >= inst.barTop;
    inst.strip.classList.toggle('is-stuck', stuck);
    if (!stuck) setInline(inst.strip, 'top', '');
    var spacer = ensureSpacer(inst);
    setInline(spacer, 'height', stuck ? inst.strip.offsetHeight + 'px' : '0px');
  }

  function setBodyClass(name, on) {
    var body = root.document.body;
    if (!body) return;
    var has = body.classList.contains(name);
    if (on) {
      if (!has) body.classList.add(name);
    } else if (has) {
      body.classList.remove(name);
    }
  }

  function setBodyVar(name, value) {
    var body = root.document.body;
    if (!body || !body.style) return;
    var current = String(body.style.getPropertyValue(name) || '').trim();
    var next = value == null || value === '' ? '' : String(value).trim();
    if (current === next) return;
    if (!next) body.style.removeProperty(name);
    else body.style.setProperty(name, next);
  }

  function clearStickyGlobals() {
    /* Multi-token classList.remove records a class mutation in Chrome 156
       even when neither token is present. Write only a real change. */
    setBodyClass('has-sticky-announcement-bar', false);
    setBodyClass('has-sticky-announcement-bar--below', false);
    setBodyVar('--sticky-announcement-bar-height', '');
  }

  function nativeBar() {
    var slider = root.document.getElementById('AnnouncementSlider');
    return slider ? slider.closest('.announcement-bar') : null;
  }

  function setInline(node, name, value) {
    if (!node || !node.style) return;
    var current = String(node.style.getPropertyValue(name) || '');
    var next = value == null || value === '' ? '' : String(value);
    if (current === next) return;
    if (!next) node.style.removeProperty(name);
    else node.style.setProperty(name, next);
  }

  function releaseNativeSticky(force) {
    if (!ownsVisibleStrip()) return;
    var bar = nativeBar();
    if (!bar || bar.getAttribute('data-sticky') !== 'true') return;
    var reclaimed = bar.classList.contains('announcement-bar--sticky');
    if (!force && coord.releasedNative && !reclaimed) return;
    var api = root.theme && root.theme.announcementBar;
    if (api && typeof api.unload === 'function') {
      try {
        api.unload();
      } catch (error) {
        if (typeof root.off === 'function') {
          try { root.off('scroll.announcementSticky'); } catch (ignore) {}
        }
      }
    }
    /* theme.announcementBar.unload() removes the spacer it captured in
       initSticky. Do not delete anonymous siblings by appearance. If init
       has not run, that closure has no spacer node to remove. */
    if (bar.classList.contains('announcement-bar--sticky')) bar.classList.remove('announcement-bar--sticky');
    if (bar.style.top) bar.style.top = '';
    coord.releasedNative = true;
  }

  function restoreNative() {
    if (ownsVisibleStrip()) return;
    coord.releasedNative = false;
    var api = root.theme && root.theme.announcementBar;
    if (!api || typeof api.init !== 'function') return;
    if (!root.document.getElementById('AnnouncementSlider')) return;
    try { api.init(); } catch (error) {}
  }

  function stuckInstances() {
    return coord.list.filter(function (inst) {
      return inst.strip.isConnected && !inst.strip.hasAttribute('hidden') && inst.strip.classList.contains('is-stuck');
    }).sort(function (a, b) {
      var position = a.strip.compareDocumentPosition(b.strip);
      if (position & root.Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (position & root.Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });
  }

  function publishSticky() {
    if (!ownsVisibleStrip()) {
      if (coord.wasOwner) {
        coord.wasOwner = false;
        coord.releasedNative = false;
        clearStickyGlobals();
        coord.list.forEach(function (inst) { inst.strip.style.top = ''; });
        if (coord.allowNativeRestore !== false) restoreNative();
        else coord.pendingNativeRestore = true;
      }
      return;
    }
    coord.wasOwner = true;
    releaseNativeSticky(false);
    var stuck = stuckInstances();
    if (!stuck.length) {
      clearStickyGlobals();
      coord.list.forEach(function (inst) { inst.strip.style.top = ''; });
      return;
    }
    var offset = 0;
    var headerPush = 0;
    var anyBelow = false;
    stuck.forEach(function (inst) {
      inst.belowHeader = detectBelowHeader(inst.strip);
      var height = inst.strip.offsetHeight;
      if (inst.belowHeader) {
        anyBelow = true;
        var header = root.document.querySelector('.site-header--stuck');
        var headerHeight = header ? header.offsetHeight : 0;
        setInline(inst.strip, 'top', (headerHeight + offset) + 'px');
      } else {
        setInline(inst.strip, 'top', offset + 'px');
        headerPush += height;
      }
      offset += height;
      if (inst.spacer) setInline(inst.spacer, 'height', height + 'px');
    });
    /* Native CSS does not make these classes mutually exclusive. The push
       class moves .site-header--opening by the variable; the below class only
       changes .announcement-bar stacking. Suppressing the push whenever any
       strip is below leaves a gap between the header and that strip. */
    setBodyClass('has-sticky-announcement-bar', headerPush > 0);
    setBodyClass('has-sticky-announcement-bar--below', anyBelow);
    if (headerPush > 0) setBodyVar('--sticky-announcement-bar-height', headerPush + 'px');
    else setBodyVar('--sticky-announcement-bar-height', '');
  }

  function queueGeometry(inst) {
    if (inst) inst.measurePause = true;
    if (coord.geometryQueued) return;
    coord.geometryQueued = true;
    root.requestAnimationFrame(function () {
      coord.geometryQueued = false;
      coord.list.forEach(function (item) {
        if (!item || item.destroyed || !item.strip || !item.strip.isConnected) return;
        if (item.measurePause) {
          item.measurePause = false;
          syncPauseSpace(item);
        }
        syncSticky(item);
      });
      publishSticky();
    });
  }

  function observeGeometry(inst) {
    if (!inst || inst.resizeObserver || typeof root.ResizeObserver !== 'function') return;
    inst.resizeObserver = new root.ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === inst.pauseButton) inst.measurePause = true;
      });
      queueGeometry();
    });
    inst.resizeObserver.observe(inst.strip);
    if (inst.pauseButton) inst.resizeObserver.observe(inst.pauseButton);
  }

  function syncPresentation(inst) {
    disarmClones(inst.strip);
    syncPauseSpace(inst);
    if (!parityOn()) {
      inst.strip.setAttribute('hidden', '');
      inst.strip.classList.remove('is-stuck', 'is-revealing');
      inst.strip.style.top = '';
      if (inst.nativeBar) inst.nativeBar.removeAttribute('hidden');
      removeSpacer(inst);
      inst.barTop = null;
      return;
    }
    inst.strip.removeAttribute('hidden');
    if (inst.nativeBar) inst.nativeBar.setAttribute('hidden', '');
    applyPause(inst);
    syncSticky(inst);
  }

  function originalList(strip) {
    return strip.querySelector('.lshk-trust-strip__list:not([aria-hidden="true"])');
  }

  function blockItem(strip, blockId) {
    var list = originalList(strip);
    if (!list || !blockId) return null;
    return list.querySelector('[data-block-id="' + cssEscape(blockId) + '"]');
  }

  function scrollItemIntoView(inst, item) {
    var viewport = inst.strip.querySelector('.lshk-trust-strip__viewport');
    if (!viewport || !item) return;
    syncPauseSpace(inst);
    var pause = inst.pauseButton;
    var pauseOverlap = 0;
    if (pause) {
      var pauseStyle = root.getComputedStyle(pause);
      if (pauseStyle.display !== 'none' && pauseStyle.visibility !== 'hidden') {
        var pauseRect = pause.getBoundingClientRect();
        var earlyView = viewport.getBoundingClientRect();
        if (pauseRect.left < earlyView.right) pauseOverlap = Math.max(0, earlyView.right - pauseRect.left) + 4;
      }
    }
    var viewRect = viewport.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var limitRight = viewRect.right - pauseOverlap;
    var pageX = root.scrollX;
    if (itemRect.left < viewRect.left || itemRect.width > (limitRight - viewRect.left)) {
      viewport.scrollLeft += itemRect.left - viewRect.left;
    } else if (itemRect.right > limitRight) {
      viewport.scrollLeft += itemRect.right - limitRight;
    }
    if (root.scrollX !== pageX) root.scrollTo(pageX, root.scrollY);
  }

  function mount(shell) {
    if (!shell || !shell.querySelector) return null;
    var strip = shell.querySelector('[data-lshk-trust-strip]');
    if (!strip) return null;
    var existing = coord.registry.get(shell);
    if (existing) {
      syncPresentation(existing);
      return existing;
    }
    var inst = {
      shell: shell,
      strip: strip,
      pauseButton: strip.querySelector('[data-lshk-trust-pause]'),
      nativeBar: shell.querySelector('.announcement-bar'),
      userPaused: false,
      editorPaused: false,
      sectionSelected: false,
      blockSelected: false,
      spacer: null,
      barTop: null,
      belowHeader: false,
      resizeObserver: null
    };
    observeGeometry(inst);
    inst.onPauseClick = function () {
      inst.userPaused = nextPaused(inst.userPaused, false, true).userPaused;
      applyPause(inst);
    };
    inst.onFocusIn = function (event) {
      var link = event.target.closest && event.target.closest('a, button, input, select, textarea');
      if (!link || !inst.strip.contains(link)) return;
      if (link.closest('[aria-hidden="true"]') || link.closest('[inert]')) {
        var block = link.closest('[data-block-id]');
        var original = block && blockItem(inst.strip, block.getAttribute('data-block-id'));
        var originalLink = original && original.querySelector('a, button');
        if (originalLink) originalLink.focus();
        return;
      }
      if (!link.classList.contains('lshk-trust-strip__link')) return;
      inst.strip.classList.add('is-revealing');
      scrollItemIntoView(inst, link);
      queueGeometry();
    };
    inst.onFocusOut = function () {
      root.setTimeout(function () {
        if (!inst.strip.isConnected) return;
        if (!inst.strip.contains(root.document.activeElement) && !inst.sectionSelected && !inst.blockSelected) {
          inst.strip.classList.remove('is-revealing');
          queueGeometry();
        }
      }, 0);
    };
    if (inst.pauseButton) inst.pauseButton.addEventListener('click', inst.onPauseClick);
    inst.strip.addEventListener('focusin', inst.onFocusIn);
    inst.strip.addEventListener('focusout', inst.onFocusOut);
    coord.registry.set(shell, inst);
    coord.list.push(inst);
    syncPresentation(inst);
    return inst;
  }

  function destroy(inst) {
    if (!inst || inst.destroyed) return;
    inst.destroyed = true;
    if (inst.resizeObserver) {
      inst.resizeObserver.disconnect();
      inst.resizeObserver = null;
    }
    if (inst.pauseButton && inst.onPauseClick) inst.pauseButton.removeEventListener('click', inst.onPauseClick);
    if (inst.onFocusIn) inst.strip.removeEventListener('focusin', inst.onFocusIn);
    if (inst.onFocusOut) inst.strip.removeEventListener('focusout', inst.onFocusOut);
    inst.strip.classList.remove('is-stuck', 'is-paused', 'is-reduced', 'is-revealing');
    inst.strip.style.top = '';
    removeSpacer(inst);
    var index = coord.list.indexOf(inst);
    if (index !== -1) coord.list.splice(index, 1);
    if (inst.shell) coord.registry.delete(inst.shell);
    publishSticky();
  }

  function sweepDisconnected() {
    coord.list.slice().forEach(function (inst) {
      if (!inst.shell.isConnected || !inst.strip.isConnected) destroy(inst);
    });
  }

  function scan(scope) {
    shellsFrom(scope || root.document).forEach(mount);
    sweepDisconnected();
    publishSticky();
  }

  function instanceFromEvent(event) {
    var target = event.target;
    var shell = target && target.closest && target.closest('.lshk-announcement-shell');
    var blockId = event.detail && event.detail.blockId;
    if (!shell && blockId) {
      var item = root.document.querySelector('[data-block-id="' + cssEscape(blockId) + '"]');
      if (item && item.closest('[aria-hidden="true"]')) {
        item = blockItem(root.document, blockId);
      }
      shell = item && item.closest && item.closest('.lshk-announcement-shell');
    }
    if (!shell) {
      var shells = shellsFrom(target);
      shell = shells[0] || null;
    }
    return shell ? mount(shell) : null;
  }

  function onSectionLoad(event) {
    sweepDisconnected();
    shellsFrom(event.target).forEach(mount);
    if (!ownsVisibleStrip() && coord.pendingNativeRestore) {
      coord.pendingNativeRestore = false;
      restoreNative();
    } else {
      coord.pendingNativeRestore = false;
      publishSticky();
    }
    root.setTimeout(function () {
      coord.releasedNative = false;
      coord.list.forEach(syncPresentation);
      publishSticky();
    }, 0);
  }

  function onSectionUnload(event) {
    var target = event && event.target;
    if (!target || target.nodeType !== 1) return;
    var owned = [];
    function take(inst) {
      if (inst && !inst.destroyed && owned.indexOf(inst) === -1) owned.push(inst);
    }
    shellsFrom(target).forEach(function (shell) {
      take(coord.registry.get(shell));
    });
    coord.list.slice().forEach(function (inst) {
      if (target.contains && target.contains(inst.shell)) take(inst);
    });
    if (!owned.length) return;
    coord.allowNativeRestore = false;
    owned.forEach(destroy);
    sweepDisconnected();
    coord.allowNativeRestore = true;
  }

  function onSectionSelect(event) {
    shellsFrom(event.target).forEach(function (shell) {
      var inst = mount(shell);
      if (!inst) return;
      inst.sectionSelected = true;
      inst.editorPaused = true;
      if (parityOn()) inst.strip.removeAttribute('hidden');
      applyPause(inst);
      if (typeof inst.strip.scrollIntoView === 'function') {
        inst.strip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
  }

  function onSectionDeselect(event) {
    shellsFrom(event.target).forEach(function (shell) {
      var inst = coord.registry.get(shell);
      if (!inst) return;
      inst.sectionSelected = false;
      inst.editorPaused = !!inst.blockSelected;
      applyPause(inst);
      if (!inst.editorPaused) inst.strip.classList.remove('is-revealing');
    });
  }

  function onBlockSelect(event) {
    var inst = instanceFromEvent(event);
    if (!inst) return;
    var blockId = event.detail && event.detail.blockId;
    inst.blockSelected = blockId || true;
    inst.editorPaused = true;
    if (parityOn()) inst.strip.removeAttribute('hidden');
    applyPause(inst);
    inst.strip.classList.add('is-revealing');
    var item = null;
    if (event.target && event.target.closest) {
      item = event.target.closest('[data-block-id]');
      if (item && item.closest('[aria-hidden="true"]')) item = null;
    }
    if (!item && blockId) item = blockItem(inst.strip, blockId);
    var focus = item && (item.querySelector('.lshk-trust-strip__link') || item);
    if (focus) scrollItemIntoView(inst, focus);
  }

  function onBlockDeselect(event) {
    var inst = instanceFromEvent(event);
    if (!inst) return;
    inst.blockSelected = false;
    inst.editorPaused = !!inst.sectionSelected;
    applyPause(inst);
    if (!inst.editorPaused && !inst.strip.contains(root.document.activeElement)) {
      inst.strip.classList.remove('is-revealing');
    }
  }

  function onScroll() {
    if (coord.scrollQueued) return;
    coord.scrollQueued = true;
    root.requestAnimationFrame(function () {
      coord.scrollQueued = false;
      sweepDisconnected();
      coord.list.forEach(syncSticky);
      publishSticky();
    });
  }

  function onResize() {
    coord.list.forEach(function (inst) {
      inst.strip.classList.remove('is-stuck');
      inst.strip.style.top = '';
      if (inst.spacer) inst.spacer.style.height = '0px';
      inst.barTop = null;
      syncPauseSpace(inst);
      syncSticky(inst);
    });
    publishSticky();
  }

  function watchMedia(query, fn) {
    if (!query) return;
    if (typeof query.addEventListener === 'function') query.addEventListener('change', fn);
    else if (typeof query.addListener === 'function') query.addListener(fn);
  }

  if (!coord.bound) {
    coord.bound = true;
    root.document.addEventListener('shopify:section:load', onSectionLoad);
    root.document.addEventListener('shopify:section:unload', onSectionUnload);
    root.document.addEventListener('shopify:section:select', onSectionSelect);
    root.document.addEventListener('shopify:section:deselect', onSectionDeselect);
    root.document.addEventListener('shopify:section:reorder', onResize);
    root.document.addEventListener('shopify:block:select', onBlockSelect);
    root.document.addEventListener('shopify:block:deselect', onBlockDeselect);
    root.document.addEventListener('page:loaded', function () {
      coord.releasedNative = false;
      coord.list.forEach(syncPresentation);
      publishSticky();
    });
    root.addEventListener('scroll', onScroll, { passive: true });
    root.addEventListener('resize', onResize);
    watchMedia(coord.reduceMotion, function () {
      coord.list.forEach(applyPause);
    });
    watchMedia(coord.narrow, onResize);
    if (!coord.classObserver && root.document.body && typeof MutationObserver === 'function') {
      coord.parityObserved = parityOn();
      coord.paritySyncing = false;
      coord.classObserver = new MutationObserver(function () {
        if (coord.paritySyncing) return;
        var next = parityOn();
        if (next === coord.parityObserved) return;
        coord.parityObserved = next;
        coord.paritySyncing = true;
        try {
          coord.list.forEach(syncPresentation);
          publishSticky();
        } finally {
          coord.paritySyncing = false;
          coord.parityObserved = parityOn();
        }
      });
      coord.classObserver.observe(root.document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  root.__lshkShellScan = scan;

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () { scan(root.document); });
  } else {
    scan(root.document);
  }
})(typeof window !== 'undefined' ? window : globalThis);
